import React, { useEffect, useMemo, useState } from "react";

import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { Typography } from "antd";
import i18next from "i18next";

import { BSCoreServicesDtoMarketplaceLogisticDataDto } from "api/reactQuery/querySchemas";
import Loader from "components/Loader";
import { getGridDefaultProps } from "constants/agGridConstants";
import Cookies from "universal-cookie";
import { useGetDistributorLogisticData } from "api/reactQuery/queryComponents";
import { dateTimeFormat } from "components/Utils/dayjsUtils";
import { dateTimeFormatter } from "components/Utils/agGrid/valueFormatters";

const LogisticsInfo: React.FC = () => {
  const [distributorId, setDistributorId] = useState<number | null>(null);

  useEffect(() => {
    const cookies = new Cookies();
    const token = cookies.get("token");
    const currentDistributorId = token?.["DistributorId"] ?? null;
    setDistributorId(currentDistributorId);
  }, []);

  const { data, isLoading } = useGetDistributorLogisticData(
    { queryParams: { distributorId } },
    { enabled: !!distributorId }
  );

  const columnDefs = useMemo<ColDef<BSCoreServicesDtoMarketplaceLogisticDataDto>[]>(() => [
    { field: "cid", headerName: i18next.t("id") },
    { field: "distributorName", headerName: i18next.t("distributor_name") },
    { field: "depotName", headerName: i18next.t("warehouse_name") },
    { field: "deliveryETA", headerName: i18next.t("delivery_eta"), valueFormatter: (params) => dateTimeFormatter(params, dateTimeFormat) },
    { field: "tripType", headerName: i18next.t("trip_type") },
    { field: "companyName", headerName: i18next.t("shipping_carrier") },
    { field: "truckRegistrationNumber", headerName: i18next.t("truck_registration_number") },
  ],
    []
  );

  return (
    <>
      <Loader background="semiLight" isLoading={isLoading || !distributorId} />

      <Typography.Title level={3} style={{ marginBottom: 20 }}>
        {i18next.t("logistics_information")}
      </Typography.Title>

      {data?.length > 0 && (
        <AgGridReact
          rowData={data ?? []}
          columnDefs={columnDefs}
          {...getGridDefaultProps()}
        />
      )}
    </>
  );
};
export default LogisticsInfo;
